import { RefObject, useEffect, useState } from 'react';

export function useIsVisible(ref: RefObject<HTMLElement>): boolean {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		if (ref.current == null) return;

		const observer = new IntersectionObserver(([entry]) => {
			setIsVisible(entry?.isIntersecting ?? false);
		});

		observer.observe(ref.current);

		return () => {
			observer.disconnect();
		};
	}, [ref]);

	return isVisible;
}
